import React from 'react';
import { Calendar, MapPin } from 'lucide-react';
import { BASE_URL } from '../config/api';

const ProjectCard = ({ project }) => (
  <div className="bg-white rounded-xl shadow hover:shadow-lg transition overflow-hidden border border-gray-100 flex flex-col">
    <div className="relative aspect-[4/3] bg-gray-100">
      <img
        src={project.image_url ? `${BASE_URL}/Project/${project.image_url}` : '/placeholder.svg'}
        alt={project.title}
        className="w-full h-full object-cover"
        loading="lazy"
        onError={e => { e.target.src = '/placeholder.jpg'; }}
      />
    </div>
    <div className="p-4 flex-1 flex flex-col">
      <h3 className="text-lg font-semibold text-gray-900 truncate">{project.title}</h3>
      <div className="flex items-center gap-3 text-xs text-gray-500 mt-1">
        <span className="flex items-center gap-1"><MapPin className="h-4 w-4" />{project.city}, {project.district}</span>
        <span className="flex items-center gap-1"><Calendar className="h-4 w-4" />{project.year}</span>
      </div>
      <p className="text-gray-600 text-sm line-clamp-2 mt-2">{project.description}</p>
      <div className="flex flex-wrap gap-1 mt-2">
        {project.tags && project.tags.map((tag, i) => (
          <span key={i} className="px-2 py-0.5 text-xs rounded-full bg-blue-100 text-blue-700">{tag}</span>
        ))}
      </div>
    </div>
  </div>
);

export default ProjectCard;